import React, { useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "./SignUp.css";
import { json, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import companyLogo from "../assets/logo/logo.png";
import { useEffect } from "react";
import { useState } from "react";
import axiosMain from "../axiosMain";
import ToastNotification from "./Toast/ToastNotification";
import OtpVerification from "./otpVerification";
import { ToastContainer } from "react-bootstrap";
import { DataContext } from "../context/DataProvider";
import { useContext } from "react";
import { useSearchParams } from 'react-router-dom';
import { BASE_URLS, TENDERTIGER, WINDOW_HREF } from "../utils/baseUrls";
import RegisterSuccess from "./RegisterSuccess";

const SignUp = ({ showModal, handleClose, showModalLogin }) => {
  const { clearDataContext } = useContext(DataContext);

  const navigate = useNavigate();
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedISDCode, setSelectedISDCode] = useState('0');
  const [activeIndex, setActiveIndex] = useState(-1);
  const [isListOpen, setIsListOpen] = useState(false);
  const [otpshowModal, setotpshowModal] = useState(false);

  const [resotp, setresOtp] = useState(0);
  const [message, setMessage] = useState("");
  const [apiResponse, setApiResponse] = useState(null);
  const wrapperRef = useRef(null);
  const [phoneNoo, setPhoneNo] = useState(0);
  const [isCheckingEmail, setIsCheckingEmail] = useState(false);
  const [succRegister, setSuccRegister] = useState(false);
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const [logInDetails, setLoginDetls] = useState({});
  const [emailError, setEmailError] = useState("");

  const validationSchema = Yup.object({
    CompanyName: Yup.string()
      .required("Please enter company name"),

    Name: Yup.string()
      .required("Please enter name"),

    Country: Yup.string()
      .required("Country is required"),

    City: Yup.number()
      .required("Please select City")
      .min(1, "Please select City"),

    MobileNo: Yup.string()
      .required("Please enter mobile number")
      .trim()
      .matches(/^[0-9]{8,12}$/, "Mobile number must be between 8 and 12 digits"),

    Email: Yup.string()
      .required("Please enter email")
      .email("Invalid email address"),
    // .test(
    //   "checkEmailUnique",
    //   "Email is already registered",
    //   async function (value) {
    //     const { path, createError } = this;

    //     if (!value) return true;

    //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //     if (!emailRegex.test(value)) return true;
    //     if (formik.values.Email === value) {
    //       return true;
    //     }
    //     try {
    //       const response = await axios.get(
    //         `${BASE_URLS}/Registration/GetEmailAvailability?email=${value}&domainName=${WINDOW_HREF}`
    //       );

    //       if (response?.data?.SuccessCode === 1) {
    //         return createError({ path, message: response.data.SuccessMessage });
    //       }

    //       return true;
    //     } catch (err) {
    //       return createError({ path, message: "Error checking email" });
    //     }
    //   }
    // ),

    // Password: Yup.string()
    //   .required("Please enter password")
    //   .min(6, "Password must be at least 6 characters"),

    InterestedIn: Yup.string()
      .required("Please enter interested in"),
  });

  const formik = useFormik({
    initialValues: {
      CompanyName: "",
      Name: "",
      Country: "95",
      City: "0",
      MobileNo: "",
      Email: "",
      InterestedIn: "",
      // Password: "",
    },
    validationSchema,

    onSubmit: async (values) => {
      // setshowSuccessModal(true);
      // return;
      // Handle login logic here

      if (!await checkEmailAvailability(values.Email)) {
        return false;
      }
      if (!formik.isValid) {
        alert("please Fill All required Field");
        return;
      }
      console.log("Form values:", values);
      axiosMain
        .post(BASE_URLS + "/Registration/UserRegistration", {
          CompanyName: values.CompanyName,
          Name: values.Name,
          CountryId: selectedISDCode.toString(),
          CountryISDCode: selectedISDCode.toString(),
          CityId: values.City,
          MobileNo: values.MobileNo,
          Email: values.Email,
          // Password: values.Password,
          // Hosturl: "http://tendertiger.co.in",
          // WebDomainUrl: "tendertiger.co.in",
          IntrestedIn: values.InterestedIn,
          // Hosturl: "https://beta.tendergpt.io",
          // WebDomainUrl: "https://beta.tendergpt.io",

          IsSMSSubscribed: false,
          OTP: 0,
          ClientDomainUrl: "",
          ConfirmationStatus: 0,
          FormId: 0,
          Designation: " ",
          // UserIPAddress: "115.246.16.140",
          // SourceUrl: "https://beta.tendergpt.io",
          refCode: code === null ? "" : code,
        })
        .then((res) => {
          if (res?.data?.SuccessCode > 0 && res?.data?.SuccessMessage !== "You are already registered with us. Kindly Login or Forgot Password") {
            ToastNotification.success(res?.data?.SuccessMessage);
            setresOtp(res?.data?.OTP);
            setPhoneNo(values.MobileNo);
            setApiResponse(res?.data);
            // if (selectedISDCode.toString() === "91") {
            setotpshowModal(true);
            setSuccRegister(true);
            // }
            resetformikform();
            handleClose();
            setLoginDetls({ email: res?.data?.Email, password: res?.data?.Password });
          }
          else {
            ToastNotification.warning(res?.data?.SuccessMessage);
            showModalLogin(true);
            resetformikform();
            handleClose();
          }

        })
        .catch((err) => {
          console.log(err);
          ToastNotification.error("Registration failed !!");
        });
    },
  });
  const handleCountryChange = (e) => {
    const countryId = e.target.value;
    const selectedCountry = countryList.find((country) => country.CountryId.toString() === countryId);
    if (selectedCountry) {
      setSelectedISDCode(selectedCountry.CountryISDCode); // Update ISD code based on selected country
    }
    formik.handleChange(e); // Let Formik handle the field change as well
  };
  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedISDCode) return; // Don't make an API call if ISD code is not selected

      try {
        const response = await axios.get(BASE_URLS + `/Registration/GetCityList?countryISDCode=${selectedISDCode}`);
        setCityList(response.data); // Assuming response.data is the city list
        setFilteredCities(response.data);
        // if (response.data.length > 0) {
        //   setSelectedCity(response.data[0].CityName); // Auto-populate with the first city name
        // }
        setSelectedCity("");
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };
    if (showModal === true) {
      fetchCities();
    }

  }, [selectedISDCode]);

  //handle cities
  const handleCityChange = (e) => {
    const value = e.target.value;
    setSelectedCity(value);

    // Filter cities based on user input
    const filtered = cityList.filter((city) =>
      city.CityName.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCities(filtered);
    setIsListOpen(true); // Show the list
  };
  const handleCitySelect = async (city) => {
    setSelectedCity(city.CityName);
    await formik.setFieldValue('City', parseInt(city.CityId));
    await formik.setFieldTouched('City', true);
    await formik.validateField('City'); // ✅ Explicitly validate the field
    setIsListOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      // Navigate down the list
      if (activeIndex < filteredCities.length - 1) {
        setActiveIndex(activeIndex + 1);
      }
    } else if (e.key === 'ArrowUp') {
      // Navigate up the list
      if (activeIndex > 0) {
        setActiveIndex(activeIndex - 1);
      }
    } else if (e.key === 'Enter' && activeIndex >= 0) {
      // Select the highlighted city
      handleCitySelect(filteredCities[activeIndex]);
    }
  };
  useEffect(() => {
    const fetchCountries = async () => {

      try {
        const response = await axiosMain.get('https://registration.tendertiger.co.in/api/Registration/GetCountryList');
        setCountryList(response.data); // Assuming response.data is the country list
        setSelectedISDCode("91");
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };
    if (showModal === true) {
      fetchCountries();
      setSelectedCity("");
    }

  }, [showModal]);
  const handleOutsideClick = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsListOpen(false); // Close the list if clicked outside
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    setActiveIndex(-1); // Reset active index when suggestions change
  }, [filteredCities]);
  //end city implement
  //Implement Interested In
  const [inputValue, setInputValue] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [validationMessage, setValidationMessage] = useState("");
  const [iisListOpen, ssetIsListOpen] = useState(false);
  const handleInputChange = async (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Split input by commas to get the selected values and check the length
    const currentSelected = selectedValues;
    const maxCount = 20;
    if (currentSelected.length > maxCount) {
      setValidationMessage("Please enter max twenty keywords.");
      return;
    } else {
      setValidationMessage("");
    }

    if (value.length > 0) {
      // Prepare FormData
      const formData = new FormData();
      formData.append("term", value); // Append the 'term' parameter with the input value

      try {
        const response = await axios.post("https://beta.tendertiger.co.in/Home/GetAdvanceSearchKeywordSuggestions", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // Set the content type for FormData
          },
        });

        if (response.data) {
          const filteredSuggestions = response.data.filter((item) =>
            item.toLowerCase().includes(value.toLowerCase())
          );
          setSuggestions(filteredSuggestions);
          ssetIsListOpen(true);
        } else {
          setSuggestions([]);
          ssetIsListOpen(false);
        }
      } catch (error) {
        console.error("Error fetching suggestions", error);
      }
    } else {
      ssetIsListOpen(false);
      setSuggestions([]);
    }
  };

  const handleSelectSuggestion = (suggestion) => {
    if (!selectedValues.includes(suggestion)) {
      const updatedValues = [...selectedValues, suggestion];
      setSelectedValues(updatedValues);
      formik.setFieldValue("InterestedIn", updatedValues.join(","))
    }
    setInputValue("");
    ssetIsListOpen(false);
  };

  const handleInputBlur = () => {
    // Delay closing the list after a short timeout
    setTimeout(() => ssetIsListOpen(false), 200);
  };

  const handleRemove = (value) => {
    setSelectedValues(selectedValues.filter((item) => item !== value));
  };

  const handleSave = () => {
    // Log selected values (comma-separated) for saving
    console.log("Saving selected values:", selectedValues.join(", "));
  };

  //End

  //End
  const checkEmailAvailability = async (inputEmail) => {
    setIsCheckingEmail(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!inputEmail || !emailRegex.test(inputEmail)) {
      return;
    }
    try {
      const response = await axios.get(
        BASE_URLS + `/Registration/GetEmailAvailability?email=${inputEmail}&domainName=${WINDOW_HREF}`
      );

      // Assuming the response returns `isAvailable` boolean.
      console.log(response.data, "checkemailavailable"); // Adjust according to your API response
      if (response !== null) {
        if (response.data.SuccessCode === 1) {
          formik.setFieldError("Email", response?.data?.SuccessMessage);
          formik.setFieldTouched("Email", true, false);
          setEmailError(response?.data?.SuccessMessage);
          //ToastContainer.success(JSON.parse(response?.data).SuccessMessage);
          return false;
        }
        else {
          formik.setFieldError("Email", "");
          setIsCheckingEmail(false);
          setEmailError("");
          return true;
          //ToastContainer.warning(JSON.parse(response?.data).SuccessMessage);
        }
      }


    } catch (error) {

    }
  };

  const handleEmailBlur = async (event) => {
    await formik.handleBlur(event);//add validation check
    const inputEmail = event.target.value;
    await checkEmailAvailability(inputEmail);
  };
  const resetformikform = () => {
    formik.resetForm();
    setSelectedCity("");
    setSelectedISDCode("91");
    formik.setFieldError("Email", "");
    setIsCheckingEmail(false);
    setEmailError("");
  }
  return (
    <>
      {/* <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header>

          <Button onClick={() => { handleClose(); resetformikform(); }} className="modal-btn-close"><i className="fa fa-close"></i></Button>
        </Modal.Header>
        <Modal.Body style={{ background: "transperant" }}>
          <div className="LoginApp">

            <form className="form" onSubmit={formik.handleSubmit}>
              <p className="form-title">Register , For Free</p>

              <div className="input-container">
                <input
                  placeholder="Enter Company Name"
                  type="text"
                  name="CompanyName"
                  value={formik.values.CompanyName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.CompanyName && formik.errors.CompanyName
                      ? "input-error"
                      : ""
                  }
                />
                {formik.touched.CompanyName && formik.errors.CompanyName ? (
                  <div className="error-message">{formik.errors.CompanyName}</div>
                ) : null}
              </div>

              <div className="input-container">
                <input
                  placeholder="Enter Name"
                  type="text"
                  name="Name"
                  value={formik.values.Name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.Name && formik.errors.Name ? "input-error" : ""
                  }
                />
                {formik.touched.Name && formik.errors.Name ? (
                  <div className="error-message">{formik.errors.Name}</div>
                ) : null}
              </div>

              <div className="input-container">
                <select
                  name="Country"
                  value={formik.values.Country}
                  onChange={(e) => { formik.handleChange(e); handleCountryChange(e) }}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.Country && formik.errors.Country
                      ? 'input-error'
                      : ''
                  }
                >
                  <option value="">Select a country</option>
                  {countryList.map((country, index) => (
                    <option key={`${country.CountryName}-${index}`} value={country.CountryId}>
                      {country.CountryName}
                    </option>
                  ))}
                </select>
                {formik.touched.Country && formik.errors.Country ? (
                  <div className="error-message">{formik.errors.Country}</div>
                ) : null}
              </div>

              <div className="input-container" ref={wrapperRef}>
                <input
                  autocomplete="off"
                  type="text"
                  name="City"
                  value={selectedCity}
                  onChange={handleCityChange}
                  onBlur={formik.handleBlur}
                  onKeyDown={handleKeyDown}
                  className={formik.touched.City && formik.errors.City ? 'input-error' : ''}
                  placeholder="Start typing a city..."
                  onFocus={() => setIsListOpen(true)}
                />
                {isListOpen && filteredCities.length > 0 && (
                  <ul className="autocomplete-suggestions">
                    {filteredCities.map((city, index) => (
                      <li
                        key={`${city.CityId}-${index}`}
                        onClick={() => handleCitySelect(city)}
                        className={index === activeIndex ? 'active' : ''}
                      >
                        {city.CityName}
                      </li>
                    ))}
                  </ul>
                )}
                {formik.touched.City && formik.errors.City && (
                  <div className="error-message">{formik.errors.City}</div>
                )}
              </div>

              

              <div className="input-container row">
                <div className="col-lg-3 col-md-3">
                  <input
                    type="text"
                    name="ISD"
                    disabled={true}
                    value={selectedISDCode}
                  />
                </div>
                <div className="col-lg-9 col-md-9">
                  <input
                    placeholder="Mobile Number"
                    type="text"
                    name="MobileNo"
                    value={formik.values.MobileNo}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className={
                      formik.touched.MobileNo && formik.errors.MobileNo
                        ? "input-error"
                        : ""
                    }
                  />
                </div>


                {formik.touched.MobileNo && formik.errors.MobileNo ? (
                  <div className="error-message">{formik.errors.MobileNo}</div>
                ) : null}
              </div>

              <div className="input-container">
                <input
                  placeholder="Email"
                  type="email"
                  name="Email"
                  value={formik.values.Email}
                  onChange={formik.handleChange}
                  // onBlur={formik.handleBlur}
                  onBlur={(e) => {
                    formik.handleBlur(e);
                    handleEmailBlur(e);
                  }}
                  className={
                    formik.touched.Email && formik.errors.Email ? "input-error" : ""
                  }
                />
                {formik.touched.Email && formik.errors.Email ? (
                  <div className="error-message">{formik.errors.Email}</div>
                ) : null}
              </div>
              <div className="input-container">
                <input
                  placeholder="Tenders Interested In"
                  type="text"
                  name="InterestedIn"
                  value={formik.values.InterestedIn}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.InterestedIn && formik.errors.InterestedIn ? "input-error" : ""
                  }
                />
                {formik.touched.InterestedIn && formik.errors.InterestedIn ? (
                  <div className="error-message">{formik.errors.InterestedIn}</div>
                ) : null}
              </div>
              

              <button className="submit" type="submit" style={{ background: isCheckingEmail ? "#a7a7a7" : "#555555" }} disabled={isCheckingEmail}>
                Sign up
              </button>

              <p
                className="signup-link"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // setotpshowModal(true);
                  showModalLogin(true);
                  handleClose(false);
                  resetformikform();
                }}
              >
                Already have an account?
                <b> Sign In</b>
              </p>
            </form>
          </div>

        </Modal.Body>

      </Modal> */}


      <Modal className="register-modal" size="md" show={showModal} onHide={handleClose} centered>
        <Modal.Header>

          <Button onClick={() => { handleClose(); resetformikform(); }} className="modal-btn-close"><i className="fa fa-close"></i></Button>
        </Modal.Header>
        <Modal.Body style={{ background: "transperant" }}>
          <div className="LoginApp">
            <div className="modal-bx-filed-set">
              <fieldset>
                <legend>Register , For Free</legend>
                <form className="form" onSubmit={formik.handleSubmit}>


                  <div className="input-container">
                    <input
                      placeholder="Enter Company Name"
                      type="text"
                      name="CompanyName"
                      value={formik.values.CompanyName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={
                        formik.touched.CompanyName && formik.errors.CompanyName
                          ? "input-error"
                          : ""
                      }
                    />
                    {formik.touched.CompanyName && formik.errors.CompanyName ? (
                      <div className="error-message">{formik.errors.CompanyName}</div>
                    ) : null}
                  </div>

                  <div className="input-container">
                    <input
                      placeholder="Enter Name"
                      type="text"
                      name="Name"
                      value={formik.values.Name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={
                        formik.touched.Name && formik.errors.Name ? "input-error" : ""
                      }
                    />
                    {formik.touched.Name && formik.errors.Name ? (
                      <div className="error-message">{formik.errors.Name}</div>
                    ) : null}
                  </div>

                  <div className="input-container">
                    <select
                      name="Country"
                      value={formik.values.Country}
                      onChange={(e) => { formik.handleChange(e); handleCountryChange(e) }}
                      onBlur={formik.handleBlur}
                      className={
                        formik.touched.Country && formik.errors.Country
                          ? 'input-error'
                          : ''
                      }
                    >
                      <option value="">Select a country</option>
                      {countryList.map((country, index) => (
                        <option key={`${country.CountryName}-${index}`} value={country.CountryId}>
                          {country.CountryName}
                        </option>
                      ))}
                    </select>
                    {formik.touched.Country && formik.errors.Country ? (
                      <div className="error-message">{formik.errors.Country}</div>
                    ) : null}
                  </div>

                  <div className="input-container" ref={wrapperRef}>
                    <input
                      type="text"
                      name="City"
                      value={selectedCity}
                      onChange={handleCityChange}
                      autoComplete="off"
                      // onBlur={formik.handleBlur}
                      // onBlur={() => {
                      //   formik.handleBlur({ target: { name: "City" } });
                      // }}
                      onKeyDown={handleKeyDown}
                      className={formik.touched.City && formik.errors.City ? 'input-error' : ''}
                      placeholder="Start typing a city..."
                      onFocus={() => setIsListOpen(true)} // Show the list on focus
                    />
                    {isListOpen && filteredCities.length > 0 && (
                      <ul className="autocomplete-suggestions" autoComplete="off">
                        {filteredCities.map((city, index) => (
                          <li
                            key={`${city.CityId}-${index}`}
                            onClick={() => handleCitySelect(city)}
                            className={index === activeIndex ? 'active' : ''}
                          >
                            {city.CityName}
                          </li>
                        ))}
                      </ul>
                    )}
                    {formik.touched.City && formik.errors.City && (
                      <div className="error-message">{formik.errors.City}</div>
                    )}
                  </div>

                  {/* <div className="input-container">
                <input
                  placeholder="Password"
                  type="password"
                  name="Password"
                  value={formik.values.Password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={
                    formik.touched.Password && formik.errors.Password
                      ? "input-error"
                      : ""
                  }
                />
                {formik.touched.Password && formik.errors.Password ? (
                  <div className="error-message">{formik.errors.Password}</div>
                ) : null}
              </div> */}

                  <div className="input-container  reg-mobile">
                    <div className="isd-code">
                      <input
                        type="text"
                        name="ISD"
                        disabled={true}
                        value={selectedISDCode}
                      />
                    </div>
                    <div className="reg-mobile-number">
                      <input
                        placeholder="Mobile Number"
                        type="text"
                        name="MobileNo"
                        value={formik.values.MobileNo}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={
                          formik.touched.MobileNo && formik.errors.MobileNo
                            ? "input-error"
                            : ""
                        }
                      />
                    </div>


                    {formik.touched.MobileNo && formik.errors.MobileNo ? (
                      <div className="error-message">{formik.errors.MobileNo}</div>
                    ) : null}
                  </div>

                  <div className="input-container">
                    <input
                      placeholder="Email"
                      type="email"
                      name="Email"
                      value={formik.values.Email}
                      onChange={formik.handleChange}
                      // onBlur={formik.handleBlur}
                      // onInput={handleEmailBlur}
                      onMouseLeave={(e) => {

                        const email = formik.values.Email?.trim();
                        if (email !== "") {
                          formik.handleBlur(e);  // still mark as touched for Formik
                          handleEmailBlur(e);
                        }
                      }}
                      onBlur={(e) => {

                        const email = formik.values.Email?.trim();
                        if (email !== "") {
                          formik.handleBlur(e);
                          handleEmailBlur(e);
                        }
                      }}
                      className={
                        (formik.touched.Email && formik.errors.Email) || emailError !== "" ? "input-error" : ""
                      }
                    />
                    {(formik.touched.Email && formik.errors.Email) || emailError !== "" ? (
                      <div className="error-message">{formik.errors.Email || emailError}</div>
                    ) : null}
                  </div>
                  <div className="input-container">
                    <input
                      placeholder="Tenders Interested In"
                      type="text"
                      name="InterestedIn"
                      value={formik.values.InterestedIn}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={
                        formik.touched.InterestedIn && formik.errors.InterestedIn ? "input-error" : ""
                      }
                    />
                    {formik.touched.InterestedIn && formik.errors.InterestedIn ? (
                      <div className="error-message">{formik.errors.InterestedIn}</div>
                    ) : null}
                  </div>
                  {/* comment for future */}
                  {/* <div className="input-container">
                <input
                  type="text"
                  className={formik.touched.InterestedIn && formik.errors.InterestedIn ? 'input-error' : ''}
                  value={inputValue}
                  placeholder="Tenders Interested In"
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                  autoComplete="off"
                />

                {validationMessage && (
                  <div className="validation-message">{validationMessage}</div>
                )}

                {iisListOpen && (
                  <ul className="autocomplete-suggestions">
                    {suggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        onClick={() => handleSelectSuggestion(suggestion)}
                        style={{ cursor: "pointer" }}
                      >
                        {suggestion}
                      </li>
                    ))}
                  </ul>
                )}

                <div className="selected-items">
                  {selectedValues.map((value, index) => (
                    <span key={index} className="selected-item">
                      {value}
                      <button
                        type="button"
                        onClick={() => handleRemove(value)}
                        style={{ marginLeft: "5px" }}
                      >
                        &times;
                      </button>
                    </span>
                  ))}
                </div>
                {formik.touched.InterestedIn && formik.errors.InterestedIn && (
                  <div className="error-message">{formik.errors.InterestedIn}</div>
                )}
              </div> */}


                  <button className="submit" type="submit" style={{ background: isCheckingEmail ? "#a7a7a7" : "#555555" }} disabled={isCheckingEmail}
                  //  disabled={!(formik.isValid && formik.dirty) || isCheckingEmail}
                  >
                    Register For Free!
                  </button>

                  {/* <p
                className="signup-link"
                style={{ cursor: "pointer" }}
               
              >
                Already have an account?
                <b> Sign In</b>
              </p> */}
                  <div className="signup-in-container">
                    <span>  Already have an account?</span>
                    <a type="" className="sign-up-in-btn " onClick={() => {
                      // setotpshowModal(true);
                      showModalLogin(true);
                      handleClose(false);
                      resetformikform();
                      clearDataContext();
                    }}>
                      Login
                    </a>
                  </div>
                </form>
              </fieldset>
            </div>
          </div>

        </Modal.Body>
        {/* <Modal.Footer>
      <p className="signup-link">
        No account? <a href="#">Sign up</a>
      </p>
    </Modal.Footer> */}
      </Modal >
      <OtpVerification otpshowModal={otpshowModal} setotpshowModal={() => setotpshowModal(false)}
        resotp={resotp} setresOtp={setresOtp} handleClose={handleClose} apiResponse={apiResponse} showModalLogin={showModalLogin} type="signupotpvalid" phoneNo={phoneNoo}
        succRegister={succRegister} setSuccRegister={setSuccRegister} logInDetails={logInDetails} />
      {/* <RegisterSuccess showSuccessModal={showSuccessModal} setShowSuccessModal={setshowSuccessModal} /> */}
    </>

  );
};

export default SignUp;
